/**
 * L2 Aetheris - Auth API client
 */

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

async function call(path, opts = {}) {
  const res = await fetch(API_BASE + path, {
    method: opts.method || 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-L2-API': '1' },
    credentials: 'same-origin',
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.error || `HTTP ${res.status}`);
  }
  return json.data;
}

export const authApi = {
  login: (account, password) => call('/auth/login', { method: 'POST', body: { account, password } }),
  logout: () => call('/auth/logout', { method: 'POST' }),
  me: () => call('/auth/me'),
  register: (data) => call('/auth/register', { method: 'POST', body: data }),
  recoverInit: (email) => call('/auth/recover/init', { method: 'POST', body: { email } }),
  recoverConfirm: (data) => call('/auth/recover/confirm', { method: 'POST', body: data }),
  changePassword: (data) => call('/auth/change-password', { method: 'POST', body: data }),
};

export const donateApi = {
  packages: (currency) => call(`/donate/packages?currency=${currency}`),
  create: (data) => call('/donate/create', { method: 'POST', body: data }),
  history: () => call('/donate/history'),
};

// === Admin API ===
const qs = (params) => {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const adminApi = {
  stats:    () => call('/admin/stats'),
  orders:   (params) => call('/admin/orders' + qs(params)),
  order:    (uid) => call('/admin/order' + qs({ uid })),
  search:   (q) => call('/admin/search' + qs({ q })),
  player:   (account) => call('/admin/player' + qs({ account })),
  audit:    (params) => call('/admin/audit' + qs(params)),
  claims:   (params) => call('/admin/claims' + qs(params)),
  exportUrl: (type, params) => API_BASE + '/admin/export' + qs({ type, format: 'csv', ...(params || {}) }),
  content:  () => call('/admin/content'),
  saveContent: (key, value) => call('/admin/content', { method: 'POST', body: { key, value } }),
  resetContent: (key) => call('/admin/content', { method: 'DELETE', body: { key } }),
  upload: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const res = await fetch(API_BASE + '/admin/upload', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-L2-API': '1' },
      credentials: 'same-origin',
      body: fd,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.success === false) {
      throw new Error(json.error || `HTTP ${res.status}`);
    }
    return json.data;
  },
  refund: (order_uid, reason) => call('/admin/refund', { method: 'POST', body: { order_uid, reason } }),
  manualClaim: (data) => call('/admin/manual-claim', { method: 'POST', body: data }),
};

export default { authApi, donateApi, adminApi };
